(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     Helpers
  --------------------------------------------------------------------- */
  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) { return r.json(); });
  }

  function moneyFormat(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{amount}}') > -1) {
      return format.replace('{{amount}}', value);
    }
    return '$' + value;
  }

  var moneyFormatStr = (window.Shopify && Shopify.money_format) || '${{amount}}';

  /* ---------------------------------------------------------------------
     Mobile nav + mega menu
  --------------------------------------------------------------------- */
  var mobileToggle = document.getElementById('HallowMobileToggle');
  var mobileNav = document.getElementById('HallowMobileNav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  var megaToggle = document.getElementById('HallowMegaToggle');
  var megaMenu = document.getElementById('HallowMegaMenu');
  if (megaToggle && megaMenu) {
    megaToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      megaMenu.classList.toggle('is-open');
    });
    document.addEventListener('click', function (e) {
      if (!megaMenu.contains(e.target) && e.target !== megaToggle) {
        megaMenu.classList.remove('is-open');
      }
    });
  }

  /* ---------------------------------------------------------------------
     Predictive search
  --------------------------------------------------------------------- */
  var searchInput = document.getElementById('HallowSearchInput');
  var searchResults = document.getElementById('HallowSearchResults');
  var searchTimer;
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) {
        searchResults.classList.remove('is-open');
        searchResults.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][fields]=title,product_type,tag')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<div style="padding:14px;font-size:13px;color:rgba(255,255,255,.5)">No matches found.</div>';
              searchResults.classList.add('is-open');
              return;
            }
            searchResults.innerHTML = products.map(function (p) {
              var img = p.featured_image ? p.featured_image.url : '';
              return '<a href="' + p.url + '" style="display:flex;align-items:center;gap:10px;padding:8px;border-radius:10px;color:inherit">' +
                '<div style="width:38px;height:38px;border-radius:8px;overflow:hidden;flex-shrink:0;background:#0d0d0d">' +
                (img ? '<img src="' + img + '" style="width:100%;height:100%;object-fit:cover">' : '') +
                '</div><div style="min-width:0"><div style="font-size:13.5px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + p.title + '</div>' +
                '<div style="font-size:12px;color:#FF6B00;font-weight:600">' + p.price + '</div></div></a>';
            }).join('');
            searchResults.classList.add('is-open');
          })
          .catch(function () {});
      }, 220);
    });
    document.addEventListener('click', function (e) {
      if (!searchResults.contains(e.target) && e.target !== searchInput) {
        searchResults.classList.remove('is-open');
      }
    });
  }

  /* ---------------------------------------------------------------------
     Wishlist (client-side, localStorage-backed)
  --------------------------------------------------------------------- */
  var WISH_KEY = 'hallow_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
    updateWishUI();
  }
  function updateWishUI() {
    var list = getWishlist();
    var countEl = document.getElementById('HallowWishCount');
    if (countEl) {
      if (list.length > 0) {
        countEl.style.display = 'grid';
        countEl.textContent = list.length;
      } else {
        countEl.style.display = 'none';
      }
    }
    document.querySelectorAll('[data-wish-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-id');
      btn.classList.toggle('is-active', list.indexOf(id) > -1);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish-toggle]');
    if (!btn) return;
    var id = btn.getAttribute('data-id');
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx > -1) { list.splice(idx, 1); } else { list.push(id); }
    setWishlist(list);
  });
  updateWishUI();

  /* ---------------------------------------------------------------------
     Cart flash toast + cart count refresh
  --------------------------------------------------------------------- */
  var flashTimer;
  function showCartFlash(product) {
    var el = document.getElementById('HallowCartFlash');
    if (!el) return;
    var img = document.getElementById('HallowFlashImage');
    var name = document.getElementById('HallowFlashName');
    if (img) img.src = (product.featured_image && (product.featured_image.src || product.featured_image)) || product.image || '';
    if (name) name.textContent = product.title || '';
    el.style.display = 'flex';
    clearTimeout(flashTimer);
    flashTimer = setTimeout(function () { el.style.display = 'none'; }, 3400);
  }
  (function showPendingFlash() {
    try {
      var pending = sessionStorage.getItem('hallow_flash');
      if (pending) {
        sessionStorage.removeItem('hallow_flash');
        showCartFlash(JSON.parse(pending));
      }
    } catch (e) {}
  })();

  /* ---------------------------------------------------------------------
     Generic "Add to cart" buttons (product cards, quick view, FBT, etc.)
  --------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    var qty = btn.getAttribute('data-quantity') || 1;
    if (!variantId) return;
    btn.disabled = true;
    fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: variantId, quantity: parseInt(qty, 10) }] })
    }).then(function (data) {
      btn.disabled = false;
      if (data.status) { return; }
      var item = (data.items && data.items[0]) || data;
      try { sessionStorage.setItem('hallow_flash', JSON.stringify({ title: item.product_title || item.title, image: item.image })); } catch (err) {}
      location.reload();
    }).catch(function () { btn.disabled = false; });
  });

  /* ---------------------------------------------------------------------
     Quick View modal
  --------------------------------------------------------------------- */
  var qvOverlay = document.getElementById('HallowQuickViewOverlay');
  var qvClose = document.getElementById('HallowQuickViewClose');
  var qvAddBtn = document.getElementById('HallowQVAddToCart');
  var qvCurrentVariant = null;

  function openQuickView(url) {
    fetchJSON(url).then(function (product) {
      qvCurrentVariant = product.variants && product.variants[0];
      document.getElementById('HallowQVType').textContent = product.type || '';
      document.getElementById('HallowQVTitle').textContent = product.title;
      document.getElementById('HallowQVPrice').textContent = moneyFormat(qvCurrentVariant.price, moneyFormatStr);
      var compareEl = document.getElementById('HallowQVComparePrice');
      if (qvCurrentVariant.compare_at_price && qvCurrentVariant.compare_at_price > qvCurrentVariant.price) {
        compareEl.style.display = 'inline';
        compareEl.textContent = moneyFormat(qvCurrentVariant.compare_at_price, moneyFormatStr);
      } else {
        compareEl.style.display = 'none';
      }
      document.getElementById('HallowQVDescription').textContent = (product.description || '').replace(/<[^>]+>/g, '').slice(0, 220);
      var img = document.getElementById('HallowQVImage');
      if (product.images && product.images[0]) {
        img.src = product.images[0];
        img.style.display = 'block';
      }
      document.getElementById('HallowQVViewFull').href = product.url;
      if (qvOverlay) qvOverlay.classList.add('is-open');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    openQuickView(btn.getAttribute('data-url'));
  });
  if (qvClose) qvClose.addEventListener('click', function () { qvOverlay.classList.remove('is-open'); });
  if (qvOverlay) qvOverlay.addEventListener('click', function (e) { if (e.target === qvOverlay) qvOverlay.classList.remove('is-open'); });
  if (qvAddBtn) {
    qvAddBtn.addEventListener('click', function () {
      if (!qvCurrentVariant) return;
      fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: qvCurrentVariant.id, quantity: 1 }] }) })
        .then(function (item) {
          try { sessionStorage.setItem('hallow_flash', JSON.stringify({ title: item.product_title || item.title, image: item.image })); } catch (err) {}
          qvOverlay.classList.remove('is-open');
          location.reload();
        });
    });
  }

  /* ---------------------------------------------------------------------
     Product page: gallery thumbs, variant pills, qty stepper, add to cart,
     buy now, tabs
  --------------------------------------------------------------------- */
  var mainImage = document.getElementById('HallowMainImage');
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = thumb.getAttribute('data-src');
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.style.borderColor = 'rgba(255,255,255,.08)'; });
      thumb.style.borderColor = '#FF6B00';
    });
  });

  var productData = window.HallowProductData;
  if (productData) {
    var selected = {};
    (productData.options || []).forEach(function (name, i) {
      var group = document.querySelector('[data-option-index="' + i + '"]');
      if (group) {
        var activePill = group.querySelector('.is-selected');
        selected[i] = activePill ? activePill.getAttribute('data-option-value') : null;
      }
    });

    function findVariant() {
      return productData.variants.find(function (v) {
        return Object.keys(selected).every(function (i) {
          return v.options[i] === selected[i];
        });
      });
    }

    document.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = group.getAttribute('data-option-index');
      group.querySelectorAll('[data-option-value]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          selected[idx] = pill.getAttribute('data-option-value');
          group.querySelectorAll('[data-option-value]').forEach(function (p) {
            var isSel = p === pill;
            p.classList.toggle('is-selected', isSel);
            p.style.borderColor = isSel ? '#FF6B00' : 'rgba(255,255,255,.18)';
            p.style.background = isSel ? 'rgba(255,107,0,.14)' : 'transparent';
          });
          var variant = findVariant();
          if (variant) {
            document.getElementById('HallowVariantId').value = variant.id;
            document.getElementById('HallowPrice').textContent = moneyFormat(variant.price, moneyFormatStr);
            var compareEl = document.getElementById('HallowComparePrice');
            if (compareEl) {
              if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                compareEl.style.display = 'inline';
                compareEl.textContent = moneyFormat(variant.compare_at_price, moneyFormatStr);
              } else {
                compareEl.style.display = 'none';
              }
            }
            var addBtn = document.getElementById('HallowAddToCart');
            if (addBtn) {
              addBtn.disabled = !variant.available;
              addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
            }
          }
        });
      });
    });

    // recently viewed
    try {
      var RV_KEY = 'hallow_recent';
      var recent = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      recent = recent.filter(function (h) { return h !== productData.handle; });
      recent.unshift(productData.handle);
      recent = recent.slice(0, 8);
      localStorage.setItem(RV_KEY, JSON.stringify(recent));

      var others = recent.filter(function (h) { return h !== productData.handle; }).slice(0, 6);
      if (others.length) {
        var grid = document.getElementById('HallowRecentlyViewedGrid');
        var section = document.getElementById('HallowRecentlyViewed');
        Promise.all(others.map(function (h) { return fetchJSON('/products/' + h + '.js').catch(function () { return null; }); }))
          .then(function (products) {
            products = products.filter(Boolean);
            if (!products.length) return;
            grid.innerHTML = products.map(function (p) {
              var img = p.images && p.images[0] ? p.images[0] : '';
              return '<a href="' + p.url + '" style="border:1px solid rgba(255,255,255,.07);border-radius:16px;overflow:hidden;display:block;color:inherit">' +
                '<div style="aspect-ratio:1/1;background:#0d0d0d">' + (img ? '<img src="' + img + '" style="width:100%;height:100%;object-fit:cover">' : '') + '</div>' +
                '<div style="padding:10px 12px"><div style="font-size:12.5px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + p.title + '</div>' +
                '<div style="font-size:13px;font-weight:700;color:#FF6B00;margin-top:2px">' + moneyFormat(p.price, moneyFormatStr) + '</div></div></a>';
            }).join('');
            if (section) section.style.display = 'block';
          });
      }
    } catch (e) {}
  }

  var productForm = document.getElementById('HallowProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = document.getElementById('HallowAddToCart');
      var formData = new FormData(productForm);
      var body = {};
      formData.forEach(function (value, key) { body[key] = value; });
      body.quantity = parseInt(body.quantity, 10) || 1;
      if (addBtn) addBtn.disabled = true;
      fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify(body) })
        .then(function (item) {
          if (addBtn) addBtn.disabled = false;
          if (item.status) {
            alert(item.description || 'Could not add this item to your cart.');
            return;
          }
          try { sessionStorage.setItem('hallow_flash', JSON.stringify({ title: item.product_title || item.title, image: item.image })); } catch (err) {}
          location.reload();
        })
        .catch(function () { if (addBtn) addBtn.disabled = false; });
    });
  }

  var qtyInput = document.getElementById('HallowQty');
  var qtyDec = document.querySelector('[data-qty-decrease]');
  var qtyInc = document.querySelector('[data-qty-increase]');
  if (qtyInput && qtyDec && qtyInc) {
    qtyDec.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    qtyInc.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
  }

  var buyNowBtn = document.getElementById('HallowBuyNow');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      var variantId = document.getElementById('HallowVariantId').value;
      var qty = qtyInput ? qtyInput.value : 1;
      buyNowBtn.disabled = true;
      fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: variantId, quantity: parseInt(qty, 10) }] }) })
        .then(function () { window.location.href = '/checkout'; });
    });
  }

  var tabBtns = document.querySelectorAll('[data-tab-btn]');
  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tab = btn.getAttribute('data-tab-btn');
      tabBtns.forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('is-active', active);
        b.style.background = active ? '#FF6B00' : 'transparent';
        b.style.color = active ? '#0D0D0D' : '#fff';
        b.style.border = active ? 'none' : '1px solid rgba(255,255,255,.16)';
      });
      document.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
        panel.style.display = panel.getAttribute('data-tab-panel') === tab ? 'block' : 'none';
      });
    });
  });

  /* ---------------------------------------------------------------------
     Cart page: qty change, remove line, coupon apply
  --------------------------------------------------------------------- */
  function cartChange(key, quantity) {
    return fetchJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: quantity }) })
      .then(function () { location.reload(); });
  }
  document.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-cart-qty-increase]');
    var decBtn = e.target.closest('[data-cart-qty-decrease]');
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (incBtn) {
      var displayInc = document.querySelector('[data-cart-qty-display][data-key="' + incBtn.getAttribute('data-key') + '"]');
      var newQtyInc = (parseInt(displayInc.textContent, 10) || 1) + 1;
      cartChange(incBtn.getAttribute('data-key'), newQtyInc);
    }
    if (decBtn) {
      var displayDec = document.querySelector('[data-cart-qty-display][data-key="' + decBtn.getAttribute('data-key') + '"]');
      var newQtyDec = Math.max(0, (parseInt(displayDec.textContent, 10) || 1) - 1);
      cartChange(decBtn.getAttribute('data-key'), newQtyDec);
    }
    if (removeBtn) {
      cartChange(removeBtn.getAttribute('data-key'), 0);
    }
  });

  var applyCouponBtn = document.getElementById('HallowApplyCoupon');
  if (applyCouponBtn) {
    applyCouponBtn.addEventListener('click', function () {
      var input = document.getElementById('HallowCouponInput');
      var msg = document.getElementById('HallowCouponMsg');
      var code = input.value.trim();
      if (!code) return;
      applyCouponBtn.disabled = true;
      fetchJSON('/cart/update.js', { method: 'POST', body: JSON.stringify({ discount: code }) })
        .then(function (cart) {
          applyCouponBtn.disabled = false;
          if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
            location.reload();
          } else if (msg) {
            msg.textContent = 'That code isn’t valid.';
          }
        })
        .catch(function () { applyCouponBtn.disabled = false; if (msg) msg.textContent = 'That code isn’t valid.'; });
    });
  }

  /* ---------------------------------------------------------------------
     Hero countdowns
  --------------------------------------------------------------------- */
  function pad(n) { return String(n).padStart(2, '0'); }

  var seasonEl = document.getElementById('HallowSeasonCountdown');
  if (seasonEl) {
    var target = new Date(seasonEl.getAttribute('data-target')).getTime();
    if (!isNaN(target)) {
      setInterval(function () {
        var diff = Math.max(0, target - Date.now());
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        seasonEl.querySelector('.cd-d').textContent = pad(d);
        seasonEl.querySelector('.cd-h').textContent = pad(h);
        seasonEl.querySelector('.cd-m').textContent = pad(m);
        seasonEl.querySelector('.cd-s').textContent = pad(s);
      }, 1000);
    }
  }

  var flashEl = document.getElementById('HallowFlashCountdown');
  if (flashEl) {
    var hours = parseFloat(flashEl.getAttribute('data-hours')) || 8;
    var FLASH_KEY = 'hallow_flashEnd';
    var flashEnd = parseInt(localStorage.getItem(FLASH_KEY), 10);
    if (!flashEnd || flashEnd < Date.now()) {
      flashEnd = Date.now() + hours * 3600 * 1000;
      try { localStorage.setItem(FLASH_KEY, String(flashEnd)); } catch (e) {}
    }
    setInterval(function () {
      var diff = Math.max(0, flashEnd - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      flashEl.querySelector('.cd-h').textContent = pad(h);
      flashEl.querySelector('.cd-m').textContent = pad(m);
      flashEl.querySelector('.cd-s').textContent = pad(s);
    }, 1000);
  }
})();
